export default __webpack_public_path__ + "static/lozenge-do-1-light-969b88267336e1731553895ee30d7bec.png";